module.exports = __webpack_public_path__ + "assets/img/ecg-yujin-icon.becad81d.png";